export default __webpack_public_path__ + "static/media/about.022600e8.jpg";